import { render, staticRenderFns } from "./RecruitmentStatus.vue?vue&type=template&id=6883aa59"
import script from "./RecruitmentStatus.vue?vue&type=script&lang=js"
export * from "./RecruitmentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports